<template>
  <div class="exchange-center">
    <el-dialog class="card-pack-dialog" :modal='false' :close-on-press-escape='false' :close-on-click-modal='false'
      v-model="cardPackDialog" center destroy-on-close :show-close="false">
      <invite-card-pack :inviteId="inviteId" />
    </el-dialog>
    <!-- <el-dialog :modal='false' top="30px" width="50%" v-model="test">
      <setting-helper />
    </el-dialog> -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from "vue-router";
import inviteCardPack from './components/inviteCardPack.vue'
import settingHelper from '@/components/SuperAIHelper/SettingHelper.vue'
const router = useRouter();
const route = useRoute();

let cardPackDialog = ref(false)
let test = ref(false)
let inviteId = ref('')
onMounted(() => {
  if (route.query.type === 'receiveCardPack') {
    inviteId.value = route.query.inviteId
    cardPackDialog.value = true
  };
})


</script>

<style lang="scss" scoped>
:deep() {

  .card-pack-dialog,
  .el-dialog {
    background-color: #1d1e1f;
    width: 30%;
    box-shadow: #1d1e1f 0px 0px 1px 898px;
  }
}
</style>